export { default } from './SearchTitleDeprecated';



// WEBPACK FOOTER //
// ./app/components/search/SearchTitleDeprecated/index.js